import { useState } from "react"
import { Icon } from "ui/Icon"
import styles from "./CustomEmailTab.module.css"

export const CopyButton = ({ value }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        setCopied(true)
        setTimeout(() => setCopied(false), 2000)
      })
      .catch(() => {})
  }

  return (
    <button type="button" className={styles.copyButton} onClick={handleCopy} title="Copy">
      <Icon type="feather" name={copied ? "Check" : "Copy"} width={14} height={14} />
    </button>
  )
}
